// @ts-nocheck — slated for deletion
/* eslint-disable */
import React, { useCallback, useMemo } from "react"

import { useActiveOrganization } from "@/contexts"
import { useAvailableReportDates } from "@/services"
import { APP_COMPANY_NAME } from "@/utils/constants"
import { getMostRecentPreviousYearDateRange } from "@/utils/date/date"
import { useDateRange } from "@/utils/date/use-date-range"
import type { Interval } from "luxon"

import { WarningAmberRounded } from "@mui/icons-material"
import { Alert, Box, FormControl, FormLabel } from "@mui/material"

import { MonthRangeSelector } from "../../../../components/date/monthRangeSelector/monthRangeSelector"
import type {
  Gri302ReportTableRow,
  Gri303ReportTableRow,
  Gri305ReportTableRow,
  Gri306ReportTableRow,
} from "../../models/gri"
import type { Report } from "../../models/report"
import { reportCard } from "../../models/report"
import { useGriReport } from "../../services/useGriReport/useGriReport"
import DataAlert from "../dataAlert/dataAlert"
import DataSummary from "../dataSummary/dataSummary"
import DownloadPreviewCsv from "../downloadPreviewCsv/downloadPreviewCsv"
import ReportLayout from "../reportLayout/reportLayout"

const Gri = () => {
  const { activeOrganization } = useActiveOrganization()
  const { availableReportDatesData } = useAvailableReportDates()

  const mostRecentPreviousYearDateRange = getMostRecentPreviousYearDateRange(
    availableReportDatesData
  )

  const { dateRange, setDateRange } = useDateRange({
    id: "reportGriDateRange",
    bounds: availableReportDatesData,
    fallbackDateRange: mostRecentPreviousYearDateRange,
  })

  const isDataReady = false

  const { griReport, isGriReportLoading } = useGriReport(
    activeOrganization?.id,
    dateRange,
    isDataReady
  )

  // Mass lint disable

  const reports: Report<
    | Gri302ReportTableRow
    | Gri303ReportTableRow
    | Gri305ReportTableRow
    | Gri306ReportTableRow
    // Mass eslint disable @typescript-eslint/no-unsafe-return
  >[] = useMemo(() => (griReport ? Object.values(griReport) : []), [griReport])

  const handleDateRangeChange = useCallback(
    (value: Interval | null): void => {
      if (value?.isValid) {
        setDateRange(value)
      }
    },
    [setDateRange]
  )

  return (
    <ReportLayout
      actions={
        <DownloadPreviewCsv
          isDisabled={!griReport || isGriReportLoading}
          isLoading={isGriReportLoading}
          report={reports}
        />
      }
      details={
        <DataSummary>
          <Box component="p" sx={{ mt: 0, mb: 2 }}>
            Your data download includes 4 individual CSV files for energy
            (GRI–302), water (GRI–303), emissions (GRI–305), and waste (GRI–306)
          </Box>
          <Box component="p" sx={{ m: 0 }}>
            Your emissions CSV (GRI-305) will include two data points for scope
            2 emissions:
          </Box>
          <Box component="ol" sx={{ mt: 0, mb: 2, pl: 2.5 }}>
            <li>Location based emissions (eGRID)</li>
            <li>{`${APP_COMPANY_NAME} advanced grid study`}</li>
          </Box>
          <Alert icon={<WarningAmberRounded />} severity="warning">
            This download does not include market-based emissions. Contact us to
            explore adding them.
          </Alert>
        </DataSummary>
      }
      filters={
        <FormControl>
          <FormLabel sx={{ mb: 0.5 }}>Date Range</FormLabel>
          <MonthRangeSelector
            availableMaxMinMonths={availableReportDatesData}
            onChange={handleDateRangeChange}
            value={dateRange}
          />
        </FormControl>
      }
      notifications={<DataAlert />}
      report={reportCard.Gri}
    />
  )
}

export default Gri
